{
  "$schema": "https://mux.run/theme.json",
  "name": "Kettle Classic",
  "id": "mux-classic",
  "light": {
    "palette": {
      "neutral": "#ffffff",
      "ink": "#1a1a1a",
      "primary": "#3b7dd8",
      "accent": "#d68c27",
      "success": "#3d9a57",
      "warning": "#d68c27",
      "error": "#d1383d",
      "info": "#318795",
      "diffAdd": "#4db380",
      "diffDelete": "#f52a65"
    },
    "overrides": {
      "text-weak": "#8a8a8a",
      "syntax-comment": "#8a8a8a",
      "syntax-keyword": "#d68c27",
      "syntax-string": "#3d9a57",
      "syntax-primitive": "#3b7dd8",
      "syntax-variable": "#d1383d",
      "syntax-property": "#318795",
      "syntax-type": "#b0851f",
      "syntax-constant": "#d68c27",
      "syntax-operator": "#318795",
      "syntax-punctuation": "#1a1a1a",
      "syntax-object": "#d1383d",
      "markdown-heading": "#d68c27",
      "markdown-text": "#1a1a1a",
      "markdown-link": "#3b7dd8",
      "markdown-link-text": "#318795",
      "markdown-code": "#3d9a57",
      "markdown-block-quote": "#b0851f",
      "markdown-emph": "#b0851f",
      "markdown-strong": "#d68c27",
      "markdown-horizontal-rule": "#8a8a8a",
      "markdown-list-item": "#3b7dd8",
      "markdown-list-enumeration": "#318795",
      "markdown-image": "#3b7dd8",
      "markdown-image-text": "#318795",
      "markdown-code-block": "#1a1a1a"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#0a0a0a",
      "ink": "#eeeeee",
      "primary": "#fab283",
      "accent": "#9d7cd8",
      "success": "#7fd88f",
      "warning": "#f5a742",
      "error": "#e06c75",
      "info": "#56b6c2",
      "diffAdd": "#b8db87",
      "diffDelete": "#e26a75"
    },
    "overrides": {
      "text-weak": "#808080",
      "syntax-comment": "#808080",
      "syntax-keyword": "#9d7cd8",
      "syntax-string": "#7fd88f",
      "syntax-primitive": "#fab283",
      "syntax-variable": "#e06c75",
      "syntax-property": "#56b6c2",
      "syntax-type": "#e5c07b",
      "syntax-constant": "#f5a742",
      "syntax-operator": "#56b6c2",
      "syntax-punctuation": "#eeeeee",
      "syntax-object": "#e06c75",
      "markdown-heading": "#9d7cd8",
      "markdown-text": "#eeeeee",
      "markdown-link": "#fab283",
      "markdown-link-text": "#56b6c2",
      "markdown-code": "#7fd88f",
      "markdown-block-quote": "#e5c07b",
      "markdown-emph": "#e5c07b",
      "markdown-strong": "#f5a742",
      "markdown-horizontal-rule": "#808080",
      "markdown-list-item": "#fab283",
      "markdown-list-enumeration": "#56b6c2",
      "markdown-image": "#fab283",
      "markdown-image-text": "#56b6c2",
      "markdown-code-block": "#eeeeee"
    }
  }
}
